var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlassSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05.546C3.724.546.196 4.074.196 8.401c0 4.328 3.528 7.865 7.866 7.865 2.008 0 3.837-.76 5.226-2.008.03.04.04.08.07.12l6.536 6.915a.75.75 0 001.07.03c.3-.28.31-.76.03-1.059l-6.536-6.916a.585.585 0 00-.19-.13 7.787 7.787 0 001.659-4.817c0-4.337-3.528-7.865-7.865-7.865l-.01.01zm0 14.221a6.376 6.376 0 01-6.366-6.366c0-3.508 2.859-6.356 6.367-6.356a6.377 6.377 0 016.366 6.366 6.376 6.376 0 01-6.366 6.366v-.01z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassSimple);
export default __webpack_public_path__ + "static/media/MagnifyingGlassSimple.9cbbaa2789f33238ee864e0e6c8f6c7f.svg";
export { ForwardRef as ReactComponent };